// Normalizacion de los errores que devuelve el auth-server de Identity.

const STATUS_FALLBACK = {
  400: "Petición incorrecta.",
  401: "Tu sesión no es válida.",
  403: "No tienes permisos.",
  404: "No encontrado.",
  409: "El recurso ya existe.",
  422: "Datos inválidos.",
  500: "Error interno del servidor.",
  502: "Servicio no disponible.",
  503: "Servicio no disponible.",
  504: "Servidor tardó demasiado."
};

export const DEFAULT_ERROR_MESSAGE = "Ha ocurrido un error.";

export const getApiErrorMessage = (error, fallback = DEFAULT_ERROR_MESSAGE) => {
  if (!error) return fallback;

  // Errores sintéticos del cliente (pre-check de scopes, red caída, timeout).
  if (error.code === "FORBIDDEN") return "No tienes permisos.";
  if (error.code === "ERR_NETWORK") return "No se pudo conectar.";
  if (error.code === "ECONNABORTED") return "La petición tardó demasiado.";

  const data = error.response?.data;
  const backendMessage =
    typeof data === "string"
      ? data
      : data?.message ||
        data?.error_description ||
        data?.detail ||
        (typeof data?.error === "string" ? data.error : null);

  // Prioridad 1: mensaje del backend
  if (backendMessage) return backendMessage;
  // Prioridad 2: fallback en español por status code
  // Prioridad 3: fallback final
  return STATUS_FALLBACK[error.response?.status] || fallback;
};

export const isForbiddenError = (error) => error?.code === "FORBIDDEN" || error?.response?.status === 403;
